/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'attach_money': {
    width: 16,
    height: 16,
    viewBox: '0 0 10.18 18',
    data: '<path pid="0" d="M5.48 7.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21a3.986 3.986 0 0 0-3.21-3.81V0h-3v2.16C1.74 2.58.18 3.84.18 5.77c0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1H0c.12 2.19 1.76 3.42 3.68 3.83V18h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z" fill-rule="evenodd"/>'
  }
})
